import type { PermissionEnum } from '@Application/Security/Roles';
import { createSignal } from '@verclam/pulsar';

export type PermissionToRevoke = {
	readonly roleId: number;
	readonly permission: PermissionEnum;
};

/**
 * Non-null only while the "revoke a permission from a role carried by users" confirmation is open —
 * granting, and revoking from a role nobody carries, never go through this signal.
 */
const permissionToRevokeSignal = createSignal<PermissionToRevoke | null>(null);

export const setPermissionToRevoke = (context: PermissionToRevoke | null): void => {
	permissionToRevokeSignal.value = context;
};

export default permissionToRevokeSignal;
